<template>
  <el-dialog
    title="绑定车牌"
    :visible.sync="dialogVisible"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="500px"
  >
    <el-form size="small" :model="form" ref="form" label-width="120px">
      <el-form-item label="选择车辆" prop="vehicle_id" :rules="[{ required: true, message: '请选择车辆', trigger: 'change', type: 'array' }]">
        <el-select
          v-model="form.vehicle_id"
          placeholder="请选择车辆"
          clearable
          filterable
          multiple
          style="width: 300px;"
          :loading="loading"
        >
          <el-option
            v-for="item in vehicleList"
            :key="item.ma_vehicle_file_id"
            :label="item.license_number"
            :value="item.ma_vehicle_file_id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="confirmBind" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';

export default {
  name: 'BindVehicle',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    employeeId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitLoading: false,
      vehicleList: [],
      form: {
        vehicle_id: []
      }
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.getVehicleList();
        }
      },
      immediate: true
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false);
      }
    }
  },
  methods: {
    getVehicleList() {
      let self = this;
      self.loading = true;
      AfuncApi.call({
        model: 'ma_vehicle_file',
        action: 'getList',
        page: 1,
        list_rows: 1000,
        status: 1
      })
        .then(data => {
          self.loading = false;
          if (data.data && data.data.list && data.data.list.data) {
            self.vehicleList = data.data.list.data;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    confirmBind() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          if (!self.form.vehicle_id || self.form.vehicle_id.length === 0) {
            self.$message.warning('请选择车辆');
            return;
          }
          
          self.submitLoading = true;
          
          AfuncApi.call({
            model: 'ma_yg',
            action: 'bindVehicle',
            ma_yg_id: self.employeeId,
            ma_vehicle_file_id: self.form.vehicle_id.join(',')
          })
            .then(data => {
              self.submitLoading = false;
              if (data.code === 1) {
                self.$message({
                  message: data.msg || '绑定成功',
                  type: 'success'
                });
                self.closeDialog();
                self.$emit('success');
              } else {
                self.$message.error(data.msg || '绑定失败');
              }
            })
            .catch(error => {
              self.submitLoading = false;
              self.$message.error('绑定失败，请稍后重试');
            });
        }
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.form = {
        vehicle_id: []
      };
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_yg/index/part/BindVehicle.vue